import $ from 'jquery';

export function formatDate(date) {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2) 
        month = '0' + month;
    if (day.length < 2) 
        day = '0' + day;

    return [year, month, day].join('-');
}

export function selectOptionfromValue( ele )
{
    let value = ele.attr('value');
    ele.find('option').each(function(){
        if( $(this).val() == value )
        {
            $(this).prop('selected', true);
        }
    });
}

export async function ajaxCall( data, action='', method='post' )
{

    //stringify any json found inside data json
    for ( const [key, value] of Object.entries(data) )
    {
        if (typeof value === 'object' && !Array.isArray(value) ) {
            data[key] = JSON.stringify(value);
        }
    }

    let formData = new FormData();
    for (let key in data) {
        formData.append(key, data[key]);
    }
    let url = ncf.ajaxurl;
    if( action != '' )
        url += '?action='+action;

    let response = await fetch(url, {
        method: 'POST',
        body: formData
    });
    return response.json();
}

export function is_url_image( url )
{
    if( url.match(/\.(jpeg|jpg|gif|png)$/) != null )
        return true;

    return false;
}